/* eslint-disable @typescript-eslint/no-explicit-any */
import withTheme from '@mui/styles/withTheme';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const IconBase = ({ children, color, size, style = {}, width, height, ...props }: any) => {
  const reactIconBase = {
    ...React.useContext(IconBaseContext),
  } as {
    size: string;
    style: React.CSSProperties;
    color: string;
  };
  const computedSize = size || reactIconBase.size;

  const baseStyle = reactIconBase.style || {};
  const styleProp = {
    verticalAlign: 'middle',
    ...baseStyle,
    ...style,
  };

  const computedColor = color || (style as React.CSSProperties)?.color || reactIconBase.color || baseStyle.color;
  if (computedColor) {
    (styleProp as React.CSSProperties).color = computedColor;
  }

  return (
    <svg
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      height={height || computedSize}
      width={width || computedSize}
      {...reactIconBase}
      {...props}
      style={styleProp}
    >
      {children}
    </svg>
  );
};

IconBase.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

const IconBaseContext = React.createContext({
  size: '1em',
  style: {},
  color: '',
});

const Icon = ({ className, ...props }: any) => (
  <IconBase
    className={classnames('icon', className)}
    {...props}
  />
);

export const RxVisibility = (props: any) => (
  <Icon {...props}>
    <path
      fill="none"
      fillRule="evenodd"
      d="M21.967 12.591l-.181-.334c-.664-1.222-1.642-2.385-2.815-3.364l2.142-1.346a.454.454 0 0 0 .144-.624.45.45 0 0 0-.622-.144L18.21 8.302c-.113-.08-.228-.16-.343-.236a11.661 11.661 0 0 0-3.091-1.487l1.055-3.261a.451.451 0 0 0-.858-.28l-1.073 3.317a9.435 9.435 0 0 0-1.948-.207 9.51 9.51 0 0 0-1.948.206L8.93 3.037a.451.451 0 1 0-.858.28L9.127 6.58c-1.057.322-2.098.82-3.091 1.487-.116.077-.23.157-.343.237L3.266 6.779a.448.448 0 0 0-.622.145.454.454 0 0 0 .144.623L4.93 8.893a12.096 12.096 0 0 0-2.477 2.8c-.12.19-.233.382-.339.574l-.064.117-.112.199a.483.483 0 0 0 0 .476l.188.329c.859 1.584 2.247 3.069 3.909 4.184 1.874 1.256 3.92 1.92 5.915 1.92s4.04-.664 5.915-1.92c1.664-1.115 3.055-2.602 3.92-4.19l.181-.332a.482.482 0 0 0 0-.459zm-1.019.331c-1.518 2.79-5.097 5.612-8.997 5.612-3.907 0-7.479-2.823-8.988-5.61l-.005-.009-.054-.095.054-.096a8.872 8.872 0 0 1 .293-.502c1.656-2.614 5.036-5.105 8.7-5.105 3.906 0 7.48 2.821 8.988 5.61a.053.053 0 0 1 .005.008l.04.073h.013l.007.013-.056.101zm-8.997-3.738a3.628 3.628 0 0 0-3.619 3.637 3.628 3.628 0 0 0 3.62 3.636 3.628 3.628 0 0 0 3.618-3.636 3.628 3.628 0 0 0-3.619-3.637zm0 6.313a2.674 2.674 0 0 1-2.664-2.677 2.674 2.674 0 0 1 2.664-2.678c1.47 0 2.665 1.2 2.665 2.678a2.675 2.675 0 0 1-2.665 2.677z"
    />
  </Icon>
);

export const RxLoading = (props: any) => (
  <Icon
    {...props}
    width="48px"
    height="39px"
    viewBox="0 0 48 39"
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Group-5"
        fillRule="nonzero"
      >
        <path
          d="M8.52651283e-14,28.3655787 L8.52651283e-14,0.385499871 L6.60450911,0.385499871 L7.15488487,5.17736372 L7.37503517,5.17736372 C8.3657165,3.30467195 9.55818538,1.92771332 10.9524776,1.04644667 C12.3467698,0.165179883 13.7410412,0.00160712359 15.1353334,0.00160712359 C15.449462,0.00160712359 15.9777944,0.00107141988 16.7203304,-8.75089475e-14 L20.998394,6.22924003 C18.8335505,6.15373537 17.3706488,6.15373537 16.609689,6.22924003 C15.4682493,6.34249707 14.199889,6.49813522 13.2475945,6.83629999 C12.2953001,7.17446464 11.5444725,7.67722468 10.9013245,8.15162412 C9.80928439,8.95713586 8.82436167,9.96921826 8.09052366,11.8419102 L8.09052366,28.3655787 L8.52651283e-14,28.3655787 Z"
          id="r"
          fill="#767676"
        ></path>
        <polygon
          id="x"
          fill="#C5C5C5"
          points="47.4596107 -1.03215682e-13 37.5694268 13.8672789 47.3045172 27.4314203 47.97497 28.3655787 39.2501118 28.3655787 38.6082632 27.470278 33.0445061 19.7095121 20.6039699 38.5552268 12.2005457 38.5552268 28.7781523 14.0598799 18.9526101 -1.03215682e-13 27.8085263 -1.03215682e-13 33.3677147 8.15344631 39.0561865 -1.03215682e-13"
        ></polygon>
      </g>
    </g>
  </Icon>
);

export const RxVisibilityOff = (props: any) => (
  <Icon {...props}>
    <path
      fill="none"
      fillRule="evenodd"
      d="M21.468 7.583c-1.624 3.01-5.373 6.027-9.467 6.027-3.88 0-7.459-2.717-9.212-5.567-.092-.15-.178-.3-.26-.452-.725.016-1.142.036-1.13.058l.12.216.067.128c.112.21.231.419.359.627a13.077 13.077 0 0 0 2.622 3.053L2.298 13.14a.504.504 0 0 0-.152.68c.14.233.434.303.658.158l2.57-1.661c.12.087.24.174.364.258a12.19 12.19 0 0 0 3.272 1.621l-1.117 3.557a.5.5 0 0 0 .307.623c.25.084.52-.059.602-.317l1.136-3.617a9.788 9.788 0 0 0 2.063.224 9.71 9.71 0 0 0 2.062-.225l1.135 3.618a.475.475 0 0 0 .602.317.498.498 0 0 0 .307-.623l-1.117-3.556a12.195 12.195 0 0 0 3.273-1.622c.122-.084.244-.17.363-.258l2.57 1.661a.469.469 0 0 0 .657-.157.504.504 0 0 0-.152-.68l-2.268-1.468c1.242-1.067 2.278-2.336 2.98-3.669l.192-.364c.012-.022-.408-.041-1.137-.057z"
    />
  </Icon>
);

export const Logo = (props: any) => (
  <Icon {...props}>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="logo-rxdefine"
        transform="translate(-118.000000, -115.000000)"
        fillRule="nonzero"
      >
        <g
          id="logo_rxdefine-white"
          transform="translate(118.000000, 115.000000)"
        >
          <path
            d="M48.6009011,32.405496 C47.2480019,32.405496 46.0201172,32.1406036 44.9172103,31.6108108 C43.8143034,31.081018 42.8731702,30.3231314 42.0937827,29.3371282 C41.3143951,28.351125 40.7114817,27.151751 40.2850243,25.7389703 C39.858567,24.3261895 39.6453415,22.7221188 39.6453415,20.92671 C39.6453415,19.1313011 39.9026826,17.5272304 40.4173725,16.1144496 C40.9320624,14.7016689 41.6085018,13.5022949 42.4467111,12.5162917 C43.2849204,11.5302885 44.2554639,10.7724019 45.3583709,10.2426091 C46.4612778,9.71281632 47.586226,9.4479239 48.7332492,9.4479239 C49.968505,9.4479239 50.9831642,9.65395133 51.7772572,10.0660124 C52.5713502,10.4780734 53.350726,11.0372907 54.1154082,11.7436811 L53.8507118,8.38834365 L53.8507118,0.927132719 L60.3357722,0.927132719 L60.3357722,31.8757059 L55.0418454,31.8757059 L54.6006848,29.7123962 L54.4242206,29.7123962 C53.6595384,30.4776524 52.7625209,31.1178091 51.7331411,31.6328854 C50.7037613,32.1479617 49.6596917,32.405496 48.6009011,32.405496 Z M50.2773112,27.1075947 C50.9831717,27.1075947 51.6228481,26.9604323 52.1963597,26.666103 C52.7698713,26.3717737 53.3213165,25.8567051 53.8507118,25.1208818 L53.8507118,16.1585988 C53.2624948,15.628806 52.6595814,15.2608999 52.0419535,15.0548694 C51.4243256,14.8488389 50.8214122,14.7458252 50.2331952,14.7458252 C49.2038154,14.7458252 48.2920926,15.2388194 47.4979996,16.2248226 C46.7039066,17.2108258 46.3068661,18.7486734 46.3068661,20.8384116 C46.3068661,23.0164486 46.6524384,24.605803 47.3435934,25.6065227 C48.0347485,26.6072424 49.0126446,27.1075947 50.2773112,27.1075947 Z M75.8646243,32.405496 C74.3058491,32.405496 72.8500338,32.1479617 71.4971346,31.6328854 C70.1442354,31.1178091 68.967819,30.3672806 67.9678501,29.3812774 C66.9678811,28.3952741 66.1885052,27.1959002 65.629699,25.7831194 C65.0708929,24.3703387 64.791494,22.7515517 64.791494,20.92671 C64.791494,19.160734 65.0855981,17.5640214 65.6738151,16.1365242 C66.2620321,14.709027 67.0340554,13.5022949 67.9899081,12.5162917 C68.9457608,11.5302885 70.0412986,10.7724019 71.2765543,10.2426091 C72.5118039,9.71281632 73.791163,9.4479239 75.1146513,9.4479239 C76.6734264,9.4479239 78.0336579,9.71281632 79.1953866,10.2426091 C80.3571152,10.7724019 81.3276587,11.5082141 82.1070463,12.4500679 C82.8864339,13.3919218 83.4672895,14.5029983 83.8496306,15.7833308 C84.2319716,17.0636634 84.4231393,18.4543485 84.4231393,19.9554281 C84.4231393,20.5440867 84.3937289,21.103304 84.3349072,21.6330968 C84.2760855,22.1628896 84.2172647,22.5602282 84.158443,22.8251246 L71.055974,22.8251246 C71.3500826,24.4145029 72.0044642,25.5844444 73.0191386,26.3349841 C74.033813,27.0855239 75.2764028,27.4607882 76.7469454,27.4607882 C78.3057205,27.4607882 79.8791775,26.9751521 81.4673635,26.0038653 L83.6290503,29.9331421 C82.5114379,30.6983983 81.2688481,31.3017644 79.9012435,31.7432583 C78.5336389,32.1847523 77.1881126,32.405496 75.8646243,32.405496 Z M71.011858,18.5426544 L78.9086322,18.5426544 C78.9086322,17.3064712 78.6292333,16.3057666 78.0704271,15.5405103 C77.5116209,14.7752541 76.5704878,14.3926317 75.2469995,14.3926317 C74.2176197,14.3926317 73.3132495,14.7311054 72.533862,15.4080628 C71.7544744,16.0850202 71.2471448,17.1298737 71.011858,18.5426544 Z M90.0258785,31.8757059 L90.0258785,15.0548694 L87.1142188,15.0548694 L87.1142188,10.2426091 L90.0258785,10.0218632 L90.0258785,8.82983542 C90.0258785,7.68195108 90.165578,6.59294893 90.4449811,5.56279632 C90.7243842,4.5326437 91.187598,3.63495274 91.834637,2.86969651 C92.481676,2.10444028 93.319872,1.50107202 94.349252,1.05958025 C95.378632,0.618086272 96.628574,0.397342594 98.099117,0.397342594 C99.010853,0.397342594 99.841697,0.485640065 100.591674,0.662237657 C101.341651,0.838835248 101.966622,1.01543019 102.466607,1.19202778 L101.275473,5.96013891 C100.451969,5.66580959 99.702004,5.51864714 99.025554,5.51864714 C98.231461,5.51864714 97.613843,5.76146518 97.17268,6.24710856 C96.731517,6.73275194 96.510939,7.5347873 96.510939,8.65323871 L96.510939,9.97771403 L100.437268,9.97771403 L100.437268,15.0548694 L96.510939,15.0548694 L96.510939,31.8757059 L90.0258785,31.8757059 Z M106.172355,31.8757059 L106.172355,9.97771403 L112.657416,9.97771403 L112.657416,31.8757059 L106.172355,31.8757059 Z M109.392828,6.7548241 C108.304626,6.7548241 107.407609,6.43842483 106.701748,5.80561679 C105.995888,5.17280875 105.642963,4.35605715 105.642963,3.35533746 C105.642963,2.35461778 105.995888,1.54522429 106.701748,0.927132719 C107.407609,0.309041149 108.304626,0 109.392828,0 C110.51044,0 111.41481,0.309041149 112.105965,0.927132719 C112.79712,1.54522429 113.142692,2.35461778 113.142692,3.35533746 C113.142692,4.35605715 112.79712,5.17280875 112.105965,5.80561679 C111.41481,6.43842483 110.51044,6.7548241 109.392828,6.7548241 Z M118.348387,31.8757059 L118.348387,9.97771403 L123.642314,9.97771403 L124.083474,12.7591122 L124.259939,12.7591122 C125.201086,11.8761242 126.23045,11.103518 127.348063,10.4412804 C128.465675,9.77903942 129.774438,9.4479239 131.274392,9.4479239 C133.656671,9.4479239 135.384532,10.2278849 136.458028,11.7878303 C137.531525,13.3477757 138.068265,15.5110637 138.068265,18.2777593 L138.068265,31.8757059 L131.583204,31.8757059 L131.583204,19.1165937 C131.583204,17.5272154 131.369979,16.4382132 130.943521,15.8495546 C130.517064,15.2608959 129.833272,14.966571 128.892125,14.966571 C128.068621,14.966571 127.362771,15.1505241 126.774554,15.5184358 C126.186337,15.8863474 125.539308,16.4087741 124.833447,17.0857315 L124.833447,31.8757059 L118.348387,31.8757059 Z M153.376536,32.405496 C151.817761,32.405496 150.361946,32.1479617 149.009047,31.6328854 C147.656147,31.1178091 146.479731,30.3672806 145.479762,29.3812774 C144.479793,28.3952741 143.700417,27.1959002 143.141611,25.7831194 C142.582805,24.3703387 142.303406,22.7515517 142.303406,20.92671 C142.303406,19.160734 142.59751,17.5640214 143.185727,16.1365242 C143.773944,14.709027 144.545967,13.5022949 145.50182,12.5162917 C146.457673,11.5302885 147.553211,10.7724019 148.788466,10.2426091 C150.023716,9.71281632 151.303075,9.4479239 152.626563,9.4479239 C154.185338,9.4479239 155.54557,9.71281632 156.707299,10.2426091 C157.869027,10.7724019 158.839571,11.5082141 159.618958,12.4500679 C160.398346,13.3919218 160.979202,14.5029983 161.361543,15.7833308 C161.743884,17.0636634 161.935051,18.4543485 161.935051,19.9554281 C161.935051,20.5440867 161.905641,21.103304 161.846819,21.6330968 C161.787998,22.1628896 161.729177,22.5602282 161.670355,22.8251246 L148.567886,22.8251246 C148.861995,24.4145029 149.516376,25.5844444 150.531051,26.3349841 C151.545725,27.0855239 152.788315,27.4607882 154.258857,27.4607882 C155.817633,27.4607882 157.39109,26.9751521 158.979276,26.0038653 L161.140962,29.9331421 C160.02335,30.6983983 158.78076,31.3017644 157.413156,31.7432583 C156.045551,32.1847523 154.700025,32.405496 153.376536,32.405496 Z M148.52377,18.5426544 L156.420544,18.5426544 C156.420544,17.3064712 156.141145,16.3057666 155.582339,15.5405103 C155.023533,14.7752541 154.0824,14.3926317 152.758912,14.3926317 C151.729532,14.3926317 150.825162,14.7311054 150.045774,15.4080628 C149.266386,16.0850202 148.759057,17.1298737 148.52377,18.5426544 Z"
            id="redefine"
            fill="#FFFFFF"
          ></path>
          <path
            d="M0.718175399,32.405496 L0.718175399,9.97771403 L6.01210223,9.97771403 L6.4532628,13.8186924 L6.62972703,13.8186924 C7.42382003,12.3176129 8.37965837,11.2138945 9.49727073,10.5075042 C10.6148831,9.80111379 11.7324787,9.67 12.8500911,9.67 C13.1018848,9.67 13.5253762,9.6695706 14.1205652,9.66871179 L17.5497006,14.661837 C15.8144432,14.6013153 14.6418361,14.6013153 14.0318792,14.661837 C13.116944,14.7526196 12.1002739,14.8773733 11.3369504,15.1484335 C10.5736269,15.4194936 9.97179162,15.8224872 9.45626831,16.202748 C8.58092992,16.848416 7.7914528,17.6596633 7.20323577,19.1607429 L7.20323577,32.405496 L0.718175399,32.405496 Z"
            id="r"
            fill="#FFFFFF"
          ></path>
          <polygon
            id="x"
            fill="#6918D0"
            points="38.7600196 9.66871179 30.8324191 20.7842025 38.6357025 31.6567096 39.1731123 32.405496 32.1795931 32.405496 31.6651114 31.6878565 27.2054123 25.4671176 17.233545 40.5731358 10.4976753 40.5731358 23.7856631 20.9385843 15.9098769 9.66871179 23.0084473 9.66871179 27.4644842 16.2042086 32.0241499 9.66871179"
          ></polygon>
        </g>
      </g>
    </g>
  </Icon>
);

export const DefaultAvatar = (props: any) => (
  <Icon {...props}>
    <g
      id="SU:-S1:-Personal-Info"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="SU:-Profile-Photo-8.1"
        transform="translate(-118.000000, -428.000000)"
        fill="#E3E3E3"
      >
        <g
          id="graphic/profile-photo"
          transform="translate(118.000000, 428.000000)"
        >
          <g id="noun_id_1809666">
            <g
              id="noun_profile_78763"
              fillRule="nonzero"
            >
              <path
                d="M70,0 C31.3413333,0 0,31.3413333 0,70 C0,108.661778 31.3413333,140 70,140 C108.658667,140 140,108.661778 140,70 C140,31.3413333 108.658667,0 70,0 M70,134.4 C54.8488889,134.4 40.9173333,129.128222 29.9055556,120.342444 C31.8453333,119.527333 34.4757778,118.485111 35.8586667,118.001333 C39.9388889,116.557778 44.1466667,115.440889 48.3933333,114.619556 C54.2282222,113.482444 53.4706667,110.736889 53.7988889,104.628222 C53.8455556,103.746222 55.1848889,96.95 54.25,96.488 C50.3891111,94.5544444 49.2815556,88.116 49.1415556,84.2877778 C49.0591111,82.1224444 49.0046667,80.9324444 47.6217778,79.24 C46.4706667,77.8353333 45.5466667,76.2222222 44.7564444,74.592 C43.0764444,71.1231111 41.0931111,65.9866667 42.9675556,62.23 C43.3673333,61.4288889 43.876,60.676 44.1046667,59.8126667 C44.5013333,58.3473333 43.4435556,56.9722222 43.2522222,55.5193333 C43.0173333,53.7008889 42.8586667,51.8668889 42.5848889,50.05 C42.0606667,46.5966667 42.0186667,42.448 42.4682222,38.9651111 C42.9535556,35.1804444 46.0646667,31.8717778 48.5955556,29.2335556 C54.7726667,22.8153333 65.4562222,18.0926667 74.5888889,20.048 C84.2815556,22.1262222 94.6913333,26.0135556 96.824,36.6924444 C97.622,40.6653333 97.6966667,44.7377778 97.2564444,48.7573333 C96.9748889,51.3628889 95.9653333,54.1162222 95.9653333,56.7202222 C95.9653333,58.744 97.398,60.5017778 97.748,62.3995556 C98.1228889,64.4528889 97.1351111,67.7584444 96.5782222,69.7495556 C95.8237778,72.4671111 95.1517778,75.2702222 93.7564444,77.7482222 C92.4762222,80.0146667 91.0357778,81.27 90.7728889,84.042 C90.4151111,87.794 89.7866667,93.9462222 85.9164444,95.8766667 C84.9831111,96.3433333 86.1513333,103.746222 86.198,104.628222 C86.5262222,110.736889 88.5717778,113.482444 94.4035556,114.619556 C98.6502222,115.442444 102.861111,116.557778 106.941333,118.001333 C107.647556,118.247111 109.473778,119.054444 110.911111,119.696889 C99.7795556,128.879333 85.5228889,134.4 70,134.4"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);

export const RxRadioActiveIcon = withTheme((props: any) => {
  const { theme, ...rest } = props;

  return (
    <Icon {...rest}>
      <g
        id="ic/radio/active"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="radiobutton-active">
          <g id="Group-6">
            <g id="Oval">
              <use
                fill="#FFFFFF"
                fillRule="evenodd"
              ></use>
              <use
                fillOpacity="0.4"
                fill="url(#linearGradient-1)"
                fillRule="evenodd"
              ></use>
              <use
                fill="black"
                fillOpacity="1"
                filter="url(#filter-3)"
              ></use>
            </g>
            <path
              d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 Z"
              id="Oval"
              fill={theme.palette.primary.main}
              fillRule="nonzero"
            ></path>
          </g>
          <circle
            id="Oval"
            fill={theme.palette.primary.main}
            cx="12"
            cy="12"
            r="8"
          ></circle>
        </g>
      </g>
    </Icon>
  );
});

export const RxRadioBlankIcon = (props: any) => (
  <Icon {...props}>
    <defs>
      <linearGradient
        x1="100%"
        y1="100%"
        x2="0%"
        y2="-9.9009901%"
        id="linearGradient-1"
      >
        <stop
          stopColor="#DBDBDE"
          offset="0%"
        ></stop>
        <stop
          stopColor="#FFFFFF"
          offset="100%"
        ></stop>
        <stop
          stopColor="#FFFFFF"
          offset="100%"
        ></stop>
      </linearGradient>
      <circle
        id="path-2"
        cx="12"
        cy="12"
        r="12"
      ></circle>
      <filter
        x="-62.5%"
        y="-62.5%"
        width="225.0%"
        height="225.0%"
        filterUnits="objectBoundingBox"
        id="filter-3"
      >
        <feGaussianBlur
          stdDeviation="10"
          in="SourceAlpha"
          result="shadowBlurInner1"
        ></feGaussianBlur>
        <feOffset
          dx="10"
          dy="10"
          in="shadowBlurInner1"
          result="shadowOffsetInner1"
        ></feOffset>
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        ></feComposite>
        <feColorMatrix
          values="0 0 0 0 0.740186688   0 0 0 0 0.757623803   0 0 0 0 0.820397418  0 0 0 1 0"
          type="matrix"
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
        ></feColorMatrix>
        <feGaussianBlur
          stdDeviation="10"
          in="SourceAlpha"
          result="shadowBlurInner2"
        ></feGaussianBlur>
        <feOffset
          dx="-10"
          dy="-10"
          in="shadowBlurInner2"
          result="shadowOffsetInner2"
        ></feOffset>
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner2"
        ></feComposite>
        <feColorMatrix
          values="0 0 0 0 0.980392157   0 0 0 0 0.984313725   0 0 0 0 1  0 0 0 1 0"
          type="matrix"
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixInner1"></feMergeNode>
          <feMergeNode in="shadowMatrixInner2"></feMergeNode>
        </feMerge>
      </filter>
    </defs>
    <g
      id="ic/radio/inactive"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="checkbox-outline"
        transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
      >
        <polygon
          id="bounds"
          points="24 0 0 0 0 24 24 24"
        ></polygon>
      </g>
      <g id="Group-6-Copy">
        <g id="Oval">
          <use
            fill="#FFFFFF"
            fillRule="evenodd"
            {...{ xlinkHref: '#path-2' }}
          ></use>
          <use
            fillOpacity="0.4"
            fill="url(#linearGradient-1)"
            fillRule="evenodd"
            style={{ mixBlendMode: 'soft-light' }}
            {...{ xlinkHref: '#path-2' }}
          ></use>
          <use
            fill="black"
            fillOpacity="1"
            filter="url(#filter-3)"
            {...{ xlinkHref: '#path-2' }}
          ></use>
        </g>
        <path
          d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 Z"
          id="Oval-Radio-Blank"
          fill="#A1A4B0"
          fillRule="nonzero"
        ></path>
      </g>
    </g>
  </Icon>
);

export const EmailSent = (props: any) => (
  <Icon
    {...props}
    width="115px"
    height="90px"
  >
    <path
      d="M94.6429 43.202C93.6551 43.202 92.8571 44.0079 92.8571 44.9999V80.9589C92.8571 83.9328 90.4537 86.3527 87.5 86.3527H8.92857C5.9749 86.3527 3.57143 83.9328 3.57143 80.9589V27.0205C3.57143 24.0466 5.9749 21.6267 8.92857 21.6267H69.6429C70.6306 21.6267 71.4286 20.8208 71.4286 19.8287C71.4286 18.8366 70.6306 18.0308 69.6429 18.0308H8.92857C4.0051 18.0308 0 22.0633 0 27.0205V80.9589C0 85.9161 4.0051 89.9486 8.92857 89.9486H87.5C92.4235 89.9486 96.4286 85.9161 96.4286 80.9589V44.9999C96.4286 44.0079 95.6306 43.202 94.6429 43.202Z"
      fill="#051C22"
    />
    <path
      d="M76.9204 36.604C76.2611 35.8647 75.1315 35.8077 74.399 36.4707L53.2439 55.6413C50.4775 58.1496 45.9496 58.1496 43.1816 55.6413L10.1224 25.6845C9.3906 25.0175 8.26017 25.0801 7.60099 25.8177C6.94011 26.557 7.0007 27.6927 7.73332 28.3564L37.6823 55.4941L7.81291 79.5537C7.04124 80.1741 6.91846 81.3051 7.53469 82.0796C7.88785 82.5251 8.40601 82.7555 8.92897 82.7555C9.3204 82.7555 9.71502 82.6263 10.0434 82.3614L40.372 57.9319L40.7937 58.3132C42.8346 60.1617 45.4701 61.1794 48.2148 61.1794C50.9595 61.1794 53.595 60.1617 55.6342 58.3115L56.0559 57.9303L86.3845 82.3597C86.7145 82.6246 87.1075 82.7538 87.4989 82.7538C88.0243 82.7538 88.5417 82.5235 88.8956 82.0796C89.5118 81.3051 89.3851 80.1717 88.6174 79.5537L58.7439 55.492L76.7884 39.1412C77.521 38.4782 77.58 37.3416 76.9207 36.6025L76.9204 36.604Z"
      fill="#051C22"
    />
    <path
      d="M94.6429 0.0512695C83.8122 0.0512695 75 8.92387 75 19.8287C75 30.7335 83.8122 39.6061 94.6429 39.6061C105.473 39.6061 114.286 30.7335 114.286 19.8287C114.286 8.92387 105.473 0.0512695 94.6429 0.0512695ZM94.6429 36.0102C85.7804 36.0102 78.5714 28.7502 78.5714 19.8287C78.5714 10.9072 85.7804 3.64716 94.6429 3.64716C103.505 3.64716 110.714 10.9072 110.714 19.8287C110.714 28.7502 103.505 36.0102 94.6429 36.0102Z"
      fill="#051C22"
    />
    <path
      d="M100.522 13.163L91.071 22.68L88.7624 20.3556C88.0641 19.6524 86.9353 19.6524 86.2377 20.3556C85.5394 21.0587 85.5394 22.1952 86.2377 22.8976L89.8092 26.4934C90.1567 26.8434 90.6143 27.02 91.0711 27.02C91.5279 27.02 91.9855 26.8434 92.3339 26.4934L103.048 15.7058C103.747 15.0026 103.747 13.8661 103.048 13.1638C102.35 12.4599 101.221 12.4599 100.523 13.163L100.522 13.163Z"
      fill="#051C22"
    />
  </Icon>
);

export const ImgPlaceholderIcon = (props: any) => (
  <Icon
    width="64"
    height="51"
    viewBox="0 0 64 51"
    fill="none"
    {...props}
  >
    <path
      d="M60.2305 0H2.85547C1.26172 0 0 1.26172 0 2.85547V48.1445C0 49.7383 1.26172 51 2.85547 51H60.2305C61.8242 51 63.0859 49.7383 63.0859 48.1445V2.85547C63.0859 1.26172 61.8242 0 60.2305 0ZM57.375 5.71094V38.5156L45.6211 25.6328C44.4258 24.3047 42.3008 24.3047 41.1055 25.6328L36.0586 31.1445L25.0352 18.4609C23.707 16.9336 21.3164 16.9336 19.9883 18.4609L5.71094 34.7969V5.71094H57.375Z"
      fill="#FAF6FE"
    />
    <path
      d="M47.9453 19.8552C50.4759 19.8552 52.5273 17.8038 52.5273 15.2732C52.5273 12.7426 50.4759 10.6912 47.9453 10.6912C45.4147 10.6912 43.3633 12.7426 43.3633 15.2732C43.3633 17.8038 45.4147 19.8552 47.9453 19.8552Z"
      fill="#FAF6FE"
    />
  </Icon>
);
export const NurseAvatarIcon = (props) => (
  <Icon
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    {...props}
  >
    <path
      d="M47.1581 47.3685C47.1581 40.9736 41.974 35.7896 35.5791 35.7896H12.4212C6.02636 35.7896 0.842285 40.9736 0.842285 47.3685"
      stroke="#D0BFE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="24.0003"
      cy="12.6317"
      rx="11.5789"
      ry="11.5789"
      stroke="#D0BFE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const HCPIcon = (props: any) => (
  <Icon
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    {...props}
  >
    <path
      d="M14.3283 12.9594C13.8412 12.5083 13.2004 12.3077 12.5341 12.4581C11.7651 12.6085 11.1243 13.2102 10.9705 13.9872C10.8681 14.4885 10.9705 15.015 11.2269 15.4411L10.8425 15.767C9.97105 16.519 8.76634 16.6944 7.79223 16.2433C6.81812 15.7922 6.20309 14.8396 6.20309 13.8118L6.20291 11.4806C8.86855 11.1296 10.9192 8.87372 10.9192 6.21657V1.65444C10.9192 0.752043 10.1502 0 9.22745 0H8.63796C8.2278 0 7.89472 0.32592 7.89472 0.726843C7.89472 1.12795 8.22799 1.45369 8.63796 1.45369H9.22745C9.3299 1.45369 9.43253 1.55388 9.43253 1.65424V6.21637C9.43253 8.34712 7.66387 10.1017 5.45951 10.1017C3.2807 10.1017 1.4865 8.3721 1.4865 6.21637L1.48668 1.65424C1.48668 1.55405 1.58913 1.45369 1.69176 1.45369H2.28125C2.69141 1.45369 3.02449 1.12777 3.02449 0.726843C3.02449 0.325736 2.69122 0 2.28125 0H1.69176C0.769007 0 0 0.752043 0 1.65444V6.21612C0 8.87314 2.05061 11.1292 4.7163 11.4801V13.686C4.7163 14.789 5.12645 15.8168 5.84415 16.5938C6.6387 17.446 7.76655 17.9223 8.94572 17.9223C9.97091 17.9223 10.9706 17.5464 11.7396 16.8945L12.4317 16.2929C12.7649 16.3681 13.1238 16.3681 13.4569 16.2679C14.2259 16.0673 14.7898 15.4407 14.918 14.6887C15.0204 14.062 14.8154 13.4103 14.3283 12.959L14.3283 12.9594ZM13.4824 14.3883C13.4824 14.6641 13.2518 14.9148 12.944 14.9148C12.6365 14.9148 12.4057 14.6893 12.4057 14.3883C12.4057 14.1126 12.6363 13.8618 12.944 13.8618C13.2518 13.8618 13.4824 14.0874 13.4824 14.3883Z"
      fill="white"
    />
  </Icon>
);

export const CopyIcon = () => (
  <Icon
    width="20"
    height="18"
    viewBox="0 0 18 15"
  >
    <path
      d="M6.94371 -0.000152588H1.40071C1.02922 -0.000152588 0.672943 0.147609 0.410259 0.410626C0.147575 0.673644 0 1.03037 0 1.40234V8.71568C0 9.08764 0.147575 9.44437 0.410259 9.70738C0.672943 9.9704 1.02922 10.1182 1.40071 10.1182H6.94371C7.3152 10.1182 7.67148 9.9704 7.93416 9.70738C8.19685 9.44437 8.34442 9.08764 8.34442 8.71568V1.40234C8.34442 1.03037 8.19685 0.673644 7.93416 0.410626C7.67148 0.147609 7.3152 -0.000152588 6.94371 -0.000152588ZM1.40071 9.40799C1.21743 9.40766 1.04176 9.33461 0.91216 9.20485C0.782562 9.07508 0.709606 8.89919 0.709269 8.71568V1.40234C0.709606 1.21882 0.782562 1.04293 0.91216 0.913164C1.04176 0.783402 1.21743 0.710353 1.40071 0.710016H6.94371C7.12699 0.710353 7.30266 0.783402 7.43226 0.913164C7.56186 1.04293 7.63481 1.21882 7.63515 1.40234V8.71568C7.63481 8.89919 7.56186 9.07508 7.43226 9.20485C7.30266 9.33461 7.12699 9.40766 6.94371 9.40799H1.40071Z"
      fill="currentColor"
    />
    <path
      d="M9.26118 2.46691H8.95048C8.85693 2.46691 8.76721 2.50411 8.70107 2.57035C8.63492 2.63658 8.59775 2.72641 8.59775 2.82008C8.59775 2.91374 8.63492 3.00358 8.70107 3.06981C8.76721 3.13604 8.85693 3.17325 8.95048 3.17325H9.26628C9.40666 3.17359 9.54121 3.22958 9.64048 3.32897C9.73975 3.42837 9.79566 3.56308 9.796 3.70364V10.5975C9.79566 10.781 9.72271 10.9569 9.59311 11.0867C9.46351 11.2164 9.28784 11.2895 9.10456 11.2898H3.97541C3.83558 11.2898 3.70141 11.2345 3.60218 11.1358C3.50295 11.0372 3.44669 10.9033 3.44568 10.7633C3.44568 10.6696 3.40852 10.5798 3.34237 10.5135C3.27622 10.4473 3.18651 10.4101 3.09296 10.4101C2.99941 10.4101 2.90969 10.4473 2.84354 10.5135C2.7774 10.5798 2.74023 10.6696 2.74023 10.7633C2.74057 11.0912 2.87081 11.4055 3.10238 11.6374C3.33395 11.8693 3.64792 11.9997 3.97541 12H9.09946C9.47096 12 9.82723 11.8522 10.0899 11.5892C10.3526 11.3262 10.5002 10.9695 10.5002 10.5975V3.69982C10.4988 3.37192 10.3676 3.05795 10.1353 2.82681C9.90305 2.59566 9.58867 2.46623 9.26118 2.46691Z"
      fill="currentColor"
    />
  </Icon>
);

export const SettingsIcon = () => (
  <Icon
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <path
      d="M10.0056 5.20856C7.3667 5.20856 5.21956 7.35552 5.21956 9.99457C5.21956 12.6334 7.3667 14.7806 10.0056 14.7806C12.6444 14.7806 14.7916 12.6334 14.7916 9.99457C14.7916 7.3557 12.6443 5.20856 10.0056 5.20856ZM10.0056 13.8308C7.89033 13.8308 6.16954 12.11 6.16954 9.99475C6.16954 7.87951 7.89033 6.15872 10.0056 6.15872C12.1208 6.15872 13.8419 7.87951 13.8419 9.99475C13.8419 12.11 12.1211 13.8308 10.0056 13.8308ZM18.7988 7.62661H17.442C17.3089 7.20835 17.1403 6.80156 16.9383 6.41113L17.898 5.45126C18.3605 4.98877 18.3605 4.23579 17.898 3.77329L16.2269 2.10223C15.7644 1.64046 15.0118 1.63974 14.549 2.10223L13.5892 3.06209C13.1983 2.85975 12.7917 2.69107 12.3738 2.55782V1.20102C12.3738 0.546944 11.8413 0.0146484 11.1872 0.0146484H8.82416C8.17008 0.0146484 7.6376 0.546763 7.6376 1.20102V2.55782C7.21988 2.69107 6.8131 2.85974 6.42213 3.06209L5.46226 2.10223C4.99941 1.63883 4.24665 1.63974 3.78429 2.10223L2.11377 3.77329C1.88993 3.99661 1.76672 4.29485 1.76672 4.61264C1.76672 4.92972 1.88993 5.22778 2.11359 5.45108L3.07296 6.41045C2.87062 6.80156 2.70194 7.20801 2.56887 7.62606H1.21243C0.558355 7.62606 0.0258789 8.15854 0.0258789 8.81298V11.176C0.0258789 11.8301 0.558355 12.3624 1.21243 12.3624H2.56923C2.7023 12.7806 2.87115 13.1869 3.07332 13.5779L2.11396 14.5372C1.89011 14.7611 1.76691 15.0588 1.76691 15.3766C1.76691 15.6942 1.89011 15.9923 2.11378 16.2159L3.7843 17.8861C4.23146 18.3345 5.01598 18.3338 5.46259 17.8863L6.42232 16.927C6.8129 17.1291 7.21988 17.2974 7.63779 17.4307V18.7875C7.63779 19.4416 8.17027 19.9739 8.82435 19.9739H11.1874C11.8415 19.9739 12.3739 19.4417 12.3739 18.7875V17.4307C12.7918 17.2974 13.1984 17.1288 13.5891 16.927L14.5488 17.8861C14.7723 18.11 15.0703 18.2332 15.3878 18.2334H15.388C15.7056 18.2334 16.0036 18.1102 16.2273 17.8863L17.8984 16.2152C18.3607 15.7522 18.3607 14.9998 17.8982 14.5373L16.9385 13.5774C17.1408 13.187 17.3095 12.7802 17.4426 12.3619H18.799C19.4531 12.3619 19.9855 11.8298 19.9855 11.1756V8.81252C19.9854 8.15916 19.4532 7.62669 18.7988 7.62669L18.7988 7.62661ZM19.0355 11.1762C19.0355 11.3047 18.9273 11.4126 18.7988 11.4126H17.0865C16.8715 11.4126 16.683 11.5573 16.6275 11.7651C16.4728 12.3448 16.2415 12.9032 15.9396 13.424C15.8319 13.6101 15.8628 13.8456 16.0149 13.9979L17.2263 15.2095C17.317 15.3003 17.3167 15.4536 17.2263 15.5444L15.5552 17.2149C15.4955 17.2747 15.4244 17.2838 15.3876 17.2838C15.3508 17.2838 15.2801 17.275 15.22 17.2149L14.0084 16.0038C13.8568 15.8514 13.6213 15.8207 13.435 15.9286C12.914 16.2305 12.356 16.4617 11.7763 16.6165C11.5685 16.6717 11.4236 16.8599 11.4236 17.0751V18.788C11.4236 18.9165 11.3154 19.0243 11.1869 19.0243H8.82384C8.69535 19.0243 8.58713 18.9161 8.58713 18.788V17.0751C8.58713 16.8599 8.44242 16.6717 8.23444 16.6165C7.65472 16.4618 7.09653 16.2305 6.57551 15.9286C6.50131 15.8858 6.41935 15.865 6.33775 15.865C6.21472 15.865 6.09328 15.9124 6.00181 16.0042L4.79021 17.2158C4.73064 17.2754 4.65996 17.2842 4.62295 17.2842C4.58611 17.2842 4.51543 17.2754 4.45568 17.2153L2.78498 15.5447C2.72523 15.485 2.71641 15.414 2.71641 15.3771C2.71641 15.3403 2.72523 15.2694 2.78498 15.2099L3.99639 13.9983C4.1485 13.8458 4.17952 13.6107 4.07165 13.4244C3.76973 12.903 3.5385 12.345 3.3841 11.7654C3.32857 11.5576 3.14051 11.4129 2.92512 11.4129H1.21227C1.08378 11.4129 0.975564 11.3047 0.975564 11.1766V8.81352C0.975564 8.68503 1.08378 8.57664 1.21227 8.57664H2.92476C3.13997 8.57664 3.32821 8.43176 3.38374 8.22395C3.53814 7.64459 3.76938 7.08658 4.07165 6.5652C4.17934 6.37908 4.1485 6.1436 3.99639 5.99131L2.7848 4.77958C2.72522 4.72053 2.71641 4.64968 2.71641 4.61284C2.71641 4.57618 2.72522 4.50515 2.78497 4.44557L4.45568 2.77451C4.5461 2.68321 4.69961 2.68321 4.79056 2.77451L6.00216 3.9861C6.15462 4.13856 6.38974 4.16888 6.57588 4.06137C7.09829 3.75927 7.65648 3.52767 8.2348 3.37327C8.44261 3.3181 8.58749 3.12986 8.58749 2.91465V1.20181C8.58749 1.07332 8.69571 0.965448 8.8242 0.965448H11.1872C11.3157 0.965448 11.424 1.07367 11.424 1.20181V2.91465C11.424 3.12986 11.5687 3.3181 11.7766 3.37327C12.3555 3.52802 12.9135 3.75927 13.4354 4.06137C13.6215 4.16888 13.857 4.13821 14.0091 3.9861L15.2205 2.77451C15.3118 2.68409 15.4646 2.68409 15.5554 2.77451L17.2265 4.44557C17.3172 4.53634 17.3172 4.68951 17.2265 4.78028L16.0151 5.99201C15.8629 6.14447 15.8319 6.3796 15.9398 6.56591C16.2415 7.08657 16.4729 7.6444 16.6274 8.22466C16.6829 8.43247 16.8713 8.57717 17.0863 8.57717H18.7988C18.9273 8.57717 19.0355 8.68574 19.0355 8.81406L19.0355 11.1762Z"
      fill="black"
    />
  </Icon>
);

export const SendIcon = ({ backgroundColor, ...props }: any) => (
  <Icon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="12"
      fill={backgroundColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00371 7.45235C6.96683 7.09706 7.2092 6.91284 7.54457 7.04048L19.9557 11.7684C20.2913 11.8962 20.2911 12.1035 19.9557 12.2314L7.54457 16.9593C7.20897 17.0871 6.96682 16.9041 7.00371 16.5474L7.35697 13.1375C7.39386 12.7822 7.71295 12.4633 8.06643 12.4256L11.4039 12.0687C11.759 12.0307 11.7576 11.9689 11.4039 11.9311L8.06643 11.5742C7.71159 11.5362 7.39411 11.2189 7.35697 10.8623L7.00371 7.45235Z"
      fill="white"
    />
  </Icon>
);

export const BulletedListIcon = (props: any) => (
  <Icon
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 2.3C1.94183 2.3 2.3 1.94183 2.3 1.5C2.3 1.05817 1.94183 0.7 1.5 0.7C1.05817 0.7 0.7 1.05817 0.7 1.5C0.7 1.94183 1.05817 2.3 1.5 2.3ZM1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 7.3C1.94183 7.3 2.3 6.94183 2.3 6.5C2.3 6.05817 1.94183 5.7 1.5 5.7C1.05817 5.7 0.7 6.05817 0.7 6.5C0.7 6.94183 1.05817 7.3 1.5 7.3ZM1.5 8C2.32843 8 3 7.32843 3 6.5C3 5.67157 2.32843 5 1.5 5C0.671573 5 0 5.67157 0 6.5C0 7.32843 0.671573 8 1.5 8Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 12.3C1.94183 12.3 2.3 11.9418 2.3 11.5C2.3 11.0582 1.94183 10.7 1.5 10.7C1.05817 10.7 0.7 11.0582 0.7 11.5C0.7 11.9418 1.05817 12.3 1.5 12.3ZM1.5 13C2.32843 13 3 12.3284 3 11.5C3 10.6716 2.32843 10 1.5 10C0.671573 10 0 10.6716 0 11.5C0 12.3284 0.671573 13 1.5 13Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1.65078C5 1.45748 5.1567 1.30078 5.35 1.30078H13.65C13.8433 1.30078 14 1.45748 14 1.65078C14 1.84408 13.8433 2.00078 13.65 2.00078H5.35C5.1567 2.00078 5 1.84408 5 1.65078Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 6.35C5 6.1567 5.1567 6 5.35 6H13.65C13.8433 6 14 6.1567 14 6.35C14 6.5433 13.8433 6.7 13.65 6.7H5.35C5.1567 6.7 5 6.5433 5 6.35Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 11.35C5 11.1567 5.1567 11 5.35 11H13.65C13.8433 11 14 11.1567 14 11.35C14 11.5433 13.8433 11.7 13.65 11.7H5.35C5.1567 11.7 5 11.5433 5 11.35Z"
      fill="black"
    />
  </Icon>
);
